import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Platform, AlertController, MenuController } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, BehaviorSubject } from "rxjs";
import { AppService } from "../../../services/app.service";
import { AppRoutingModule } from "src/app/app-routing.module";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppComponent } from "src/app/app.component";
import { HomeComponent } from "../../home/home.component";
import { Storage } from "@ionic/storage";
import { MatMenuTrigger } from "@angular/material/menu";
import { async } from "@angular/core/testing";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";
import { M } from "@angular/cdk/keycodes";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-manual-header",
  templateUrl: "./manual-header.page.html",
  styleUrls: ["./manual-header.page.scss"],
})
export class ManualHeaderPage implements OnInit {
  @Input() public selectedIndex: any = 1;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  version_string: any;
  version_api: any;
  version_system: any;
  user: any = "";
  role: any = "";
  cardID: boolean;

  userID = "";
  userBu = "";
  userLoc = "";
  userSource = "";
  userRole = "";

  public appPages = [
    {
      title: "Tax Invoice",
      url: "/tax-invoice",
      icon: "mail",
      isActive: false,
      action: 1,
    },
    {
      title: "Replace",
      url: "/replace",
      icon: "paper-plane",
      isActive: false,
      action: 2,
    },
    {
      title: "Credit Note",
      url: "/credit-note",
      icon: "heart",
      isActive: false,
      action: 3,
    },
    {
      title: "No Tax ID",
      url: "/no-tax-invoice",
      icon: "archive",
      isActive: false,
      action: 4,
    },
    {
      title: "Report",
      url: "/report",
      icon: "archive",
      isActive: false,
      action: 5,
    },
    {
      title: "Resend/Print",
      url: "/resend",
      icon: "trash",
      isActive: false,
      action: 6,
    },
    {
      title: "Inquiry Data",
      url: "/inquiry",
      isActive: false,
      action: 7,
    },
    {
      title: "Config",
      url: "/customer-search",
      isActive: false,
      action: 8,
    },

    // {
    //   title: "LOGOUT",
    //   url: "/logout",
    //   icon: "warning",
    //   action: 7,
    // },
  ];

  versions: any;
  timedOutCloser;
  nameNotaxID: string;
  count = 1;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public alertController: AlertController,
    private menu: MenuController,
    public appService: AppService,
    public apiservice: ApiserviceService,
    public app: AppService,
    public version: AppRoutingModule,
    public storage: Storage,
    private route: ActivatedRoute,
    private router: Router
  ) {
    const res = _getStorage(STORAGE.DATA_CARDID);
    this.cardID = res === "1" ? true : false;

    this.appService.cardEvent.subscribe(async (v) => {
      this.cardID = v === "1" ? true : false;
    });
    this.user = _getStorage(STORAGE.userID).toUpperCase();
    this.role = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.route.queryParams.subscribe((params) => {
      console.log("params===:", params);
      if (params.noName === "no_tax") {
        this.nameNotaxID = "No Tax ID - Tax Invoice";
        this.selectedIndex = Number(params.selectedIndex);
      } else if (params.noName === "no_replace") {
        this.nameNotaxID = "No Tax ID - Replace";
        this.selectedIndex = Number(params.selectedIndex);
      } else if (params.noName === "no_cn") {
        this.nameNotaxID = "No Tax ID - Credit Note";
        this.selectedIndex = Number(params.selectedIndex);
      } else {
        this.nameNotaxID = "No Tax ID";
      }
    });
  }
  ngOnInit() {
    // this.appService.setActive(1);
    this.appPages = this.appService.mappingRoleManagement(this.appPages);
    this.version_string = this.appService.versionString;
    this.version_api = _getStorage(STORAGE.VERSION_API);
    this.version_system = _getStorage(STORAGE.VERSION_BE);
  }

  clickMenu(a, noName, url?) {
    this.selectedIndex = a;

    if (a === 4) {
      this.router.navigate([url], {
        queryParams: { noName, selectedIndex: a },
      });
    }
  }

  authSubject = new BehaviorSubject(false);
  async logout() {
    const getToken = _getStorage(STORAGE.TOKEN);

    const alert = await this.alertController.create({
      cssClass: "my-custom-class-alert",
      header: "Confirm Logout",
      buttons: [
        {
          text: "CANCEL",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {},
        },
        {
          text: "OK",
          cssClass: "alertloginOk",
          handler: async (blah) => {
            this.user = "";
            this.role = "";
            this.userLoc = "";
            const get_keyCardID = _getStorage(STORAGE.DATA_KEY_CARDID);
            console.log("get_keyCardID===: ", get_keyCardID);
            localStorage.clear();
            this.storage.clear();
            _setStorage(
              STORAGE.DATA_KEY_CARDID,
              get_keyCardID === null ? [] : get_keyCardID
            );
            setTimeout(() => {
              this.authSubject.next(false);
              this.app.resetdata();
              const newTab = window.open(
                "https://login.microsoftonline.com/common/oauth2/logout",
                "_blank",
                "popup"
              );
              if (newTab) {
                newTab.onunload = () => {
                  newTab.close();

                  window.location.replace(
                    this.apiservice.B2C_LOGOUT + getToken
                  );
                };
              }
            }, 1500);
          },
        },
      ],
    });

    await alert.present();
  }
  openEnd() {
    this.menu.open("start");
  }

  home(nameNo) {
    _setStorage("nameNo", nameNo);
    // this.storage.set("nameNo", nameNo);
    this.router.navigateByUrl("/home");
  }
  checkcardID(e) {
    let groupCardID = [];
    let get_keyCardID = _getStorage(STORAGE.DATA_KEY_CARDID);
    let card: string = e.detail.checked ? "1" : "0";
    const req = {
      bu: this.userBu,
      userid: this.userID,
      loc: this.userLoc,
      userSource: this.userSource,
      keyCard: card,
    };
    if (get_keyCardID !== null) {
      _setStorage(STORAGE.DATA_CARDID, card);
      const index = get_keyCardID.findIndex(
        (f, i) =>
          f.bu === this.userBu &&
          f.userid === this.userID &&
          f.loc === this.userLoc
      );
      if (index > -1) {
        get_keyCardID.splice(index, 1);
        groupCardID.push(...get_keyCardID, req);
        _setStorage(STORAGE.DATA_KEY_CARDID, groupCardID);
      }
    } else {
      groupCardID.push(req);
      _setStorage(STORAGE.DATA_KEY_CARDID, groupCardID);
    }
    this.appService.setCardEvent(card);
  }
  dropdown(num) {
    this.selectedIndex = num;
  }

  mouseEnter(trigger) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }
  openMyMenu() {
    this.trigger.openMenu();
  }
  closeMyMenu() {
    this.trigger.closeMenu();
  }
}
